<template>
  <v-dialog
    fullscreen
    hide-overlay 
    v-if="dialog"
    v-model="sDialog"
  >
    <v-card>
      <v-toolbar>
        <v-btn icon @click="sDialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Nova loja</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <Form @close="sDialog = false" :selectedStore="null"/>
      </v-card-text>
    </v-card>
  </v-dialog>

</template>

<script>
  import Form from './Form';
export default {

  name: 'Create',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
  },
  components: {
    Form
  },
  computed: {
    sDialog: {
      get() {
        return this.dialog;
      },
      set(value) {          
        this.$emit('closeDialog');
      }
    },
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>